var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1516 8.50003C9.63605 8.50003 10.0288 8.105 10.0288 7.61769C10.0288 7.13039 9.63605 6.73535 9.1516 6.73535C8.66714 6.73535 8.27441 7.13039 8.27441 7.61769C8.27441 8.105 8.66714 8.50003 9.1516 8.50003Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6614 8.50003C13.1458 8.50003 13.5385 8.105 13.5385 7.61769C13.5385 7.13039 13.1458 6.73535 12.6614 6.73535C12.1769 6.73535 11.7842 7.13039 11.7842 7.61769C11.7842 8.105 12.1769 8.50003 12.6614 8.50003Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64281 8.50003C6.12726 8.50003 6.51999 8.105 6.51999 7.61769C6.51999 7.13039 6.12726 6.73535 5.64281 6.73535C5.15835 6.73535 4.76562 7.13039 4.76562 7.61769C4.76562 8.105 5.15835 8.50003 5.64281 8.50003Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C13.4178 1 17 3.94 17 7.5625C17 8.98438 16.44 10.3012 15.5022 11.3731L16.5556 15L13.1778 13.1538C11.96 13.7663 10.5333 14.125 9 14.125C4.58222 14.125 1 11.185 1 7.5625C1 3.94 4.58222 1 9 1Z",
    stroke: "#222222",
    strokeWidth: 0.9,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d356cb12474733710011506c762e9313.svg";
export { ForwardRef as ReactComponent };